// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.extension-body-dialog{
    width: 100%;
    height: 100%;
    background-color: var(--background-color-4);
}`, "",{"version":3,"sources":["webpack://./src/styles/extensionToolbar.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,2CAA2C;AAC/C","sourcesContent":[".extension-body-dialog{\r\n    width: 100%;\r\n    height: 100%;\r\n    background-color: var(--background-color-4);\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
